import { inject, observer } from 'mobx-react';
import * as React from 'react';
export var Confirmation = inject('saleStore')(observer(function (props) {
    return (React.createElement("div", { className: "sale-confirmation" },
        React.createElement("h3", null,
            "Welcome ",
            props.saleStore.firstName,
            "!"),
        React.createElement("p", null, "Thanks for signing up. Please take note of your order confirmation details below."),
        React.createElement("div", { className: "confirmation__code" },
            React.createElement("p", null,
                React.createElement("strong", null, "Your order number:"),
                " ",
                props.saleStore.serviceCode,
                React.createElement("br", null),
                React.createElement("strong", null, "Your payment transaction number:"),
                ' ',
                props.saleStore.paymentReference)),
        React.createElement("h3", null, "Next Steps"),
        React.createElement("ul", null,
            React.createElement("li", null, "The provisioning process will start within the next hour."),
            React.createElement("li", null, "Your welcome pack will be sent to the email address you have provided."),
            React.createElement("li", null, "You will be notified of changes to your order's status by email."))));
}));
//# sourceMappingURL=Confirmation.js.map